module.exports = __webpack_public_path__ + "static/media/economics@2x.5e23c93b.png";